import { useProjectContext } from "components/project/projects/context";
import { useAcceptShapefileFolderChanges } from "components/project/shapefiles/hooks/accept-shapefile-folder-changes/useAcceptShapefileFolderChanges";
import { useCancelShapefileFolderChanges } from "components/project/shapefiles/hooks/cancel-shapefile-folder-changes/useCancelShapefileFolderChanges";

import { EditableLabel, FlexItem, NodeTitle } from "../../../../shared";

export interface IEditableShapefileFolderNode {
  projectId?: string;
  node;
}

export function EditableShapefileFolderNode({
  projectId,
  node
}: IEditableShapefileFolderNode) {
  const { selectedProjectId } = useProjectContext();
  const nextProjectId = projectId || selectedProjectId;

  const acceptChanges = useAcceptShapefileFolderChanges({
    node,
    projectId: nextProjectId
  });

  const cancelChanges = useCancelShapefileFolderChanges({
    node,
    projectId: nextProjectId
  });

  const isLoading = acceptChanges.isLoading || cancelChanges.isRemoving;

  return (
    <NodeTitle>
      <FlexItem>
        <EditableLabel
          isLoading={isLoading}
          onCancel={cancelChanges.mutate}
          onChange={acceptChanges.mutate}
        />
      </FlexItem>
    </NodeTitle>
  );
}
